import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NetworkService } from '../../core/services/network.service';
import { LanguageService } from '../../core/services/language.service';

@Component({
  selector: 'forgot-password-form',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ForgotPasswordComponent implements OnInit {
  title: string = 'RECOVERY.TITLE';
  form: FormGroup;

  constructor (
      private toastr: ToastrService,
      private fb: FormBuilder,
      private router: Router,
      private networkService: NetworkService,
      private languageService: LanguageService
  ) {}

  ngOnInit () {
    this.form = this.fb.group({
      email: ['', Validators.email]
    })
  }

  get email () {
    return this.form.get('email');
  }


  hasError(model:FormControl) {
    return model.invalid && (model.dirty || model.touched)
  }

  markAsDirty () {
    const controls = this.form.controls;

    for (let control in controls) {
      if (
          controls.hasOwnProperty(control) &&
          controls[control].invalid
      ) {
        controls[control].markAsDirty();
      }
    }
  }

  sendEmail ($event) {
    $event.preventDefault();

    if (this.form.invalid) {
      return this.markAsDirty();
    }

    this.networkService
        .sendEmailForResetPassword(this.form.getRawValue())
        .then(response => {
          this.toastr.success(this.languageService.translate('MESSAGES.FORGOT_PASSWORD_SUCCESS'), 'Success');
          this.router.navigate([{outlets: { popup: null}}]);
        })
        .catch(err => {
          this.toastr.error(err.error.message, 'Error');
        })
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/popups/forgot-password/forgot-password.component.ts